
/* injects from baggage-loader */

'use strict';

import reportTemplate from '!!file-loader?name=templates/[name].[ext]!./report.html';

/**
* Function that register the all routes for the view report module.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @param {any} routerHelper
*/
function routeConfig($q, $ocLazyLoad, routerHelper, navigationConstant) {
	'ngInject';

	/**
	* Route definition of the view report page.
	*/
	const indexNav = 1;
	const reportRoute = {
		state: navigationConstant.RESOURCES[indexNav].STATE,
		config: {
			url: navigationConstant.RESOURCES[indexNav].URL,
			templateUrl: reportTemplate,
			controller: 'ReportController',
			controllerAs: 'reportvm',
			resolve: {
				report: reportLazyLoading
			},
			data: {
				code: navigationConstant.RESOURCES[indexNav].CODE,
				login: true,
				pageTitle: navigationConstant.RESOURCES[indexNav].NAME,
				submenu: false
			},
		}
	}

	routerHelper.configureStates([reportRoute]);
}

/**
* Function for the lazyLoading configuration in the view report route.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @returns
*/
function reportLazyLoading($q, $ocLazyLoad) {
	'ngInject';

	const deferred = $q.defer();

	require.ensure([], require => {
		const reportModule = require('./report.module');

		$ocLazyLoad.load({
			name: reportModule.default.name,
		});

		deferred.resolve(reportModule.default.controller);
	});

	return deferred.promise;
}

export default angular
	.module('report.routes', [])
	.run(routeConfig);



// WEBPACK FOOTER //
// ./src/app/auth/management/report/report.routes.js